import { type MatrixClient } from "matrix-js-sdk/src/matrix";

import SdkConfig from "../SdkConfig";
export function isPresenceEnabled(matrixClient: MatrixClient): boolean {
    // const hsUrl = matrixClient.baseUrl;
    // const urls = SdkConfig.get("enable_presence_by_hs_url");
    // if (!urls) return true;
    // if (urls[hsUrl] || urls[hsUrl] === undefined) return true;
    // return false;
    const enablePresenceOnline = !!SdkConfig.get("enable_presence_online");
    return enablePresenceOnline;
}
